module.exports = __webpack_public_path__ + "static/media/18_B.28e45311.png";